import React from 'react';
import { Container } from '../../styles/Styles';
import AdminNav from './AdminNav';
import { useAuth } from '../../context/AuthContext';
import { Roles } from '../common/roles';
import { Navigate } from 'react-router-dom';

const AdminDashboard = () => {
    const { user, isAuthenticated } = useAuth();

    if (!isAuthenticated || user?.role[0] !== Roles.ADMIN) {
        return <Navigate to="/" />;
    }

    return (
        <Container>
            <AdminNav />
            <h2>Admin Dashboard</h2>
            <p>Welcome, {user?.email}</p>
        </Container>
    );
};

export default AdminDashboard;
